import { chain } from 'underscore';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Text } from '@bingads-webui-react/fabric-control';
import { Link } from '@bingads-webui-react/fabric-with-signal';
import { combineDescriptions } from '@bingads-webui-campaign-react/ad-common';

export const DynamicSearchAdPreview = ({ ad, i18n }) => {
  const combinedUrl = useMemo(() => chain([ad.DisplayUrl, ad.Path1, ad.Path2]).compact().join('/').value(), [ad.DisplayUrl, ad.Path1, ad.Path2]);
  const description = useMemo(() => combineDescriptions(ad.Text, ad.TextPart2), [ad.Text, ad.TextPart2]);

  return (
    <div className="dsa-ad-preview-content-container">
      <Text block className="ad-title-preview">
        {i18n.getString(_TL_('{Dynamically generated headline}'))}
      </Text>
      <Text block nowrap className="ad-url-line">
        <Link className="ad-url-preview" target="_blank" href={combinedUrl}>{combinedUrl}</Link>
      </Text>
      <Text block className="ad-description-preview">
        <span className="ad-slug">{i18n.getString(_TL_('Ad'))}</span>
        {description}
      </Text>
    </div>
  );
};

DynamicSearchAdPreview.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  ad: PropTypes.shape({
    Text: PropTypes.string,
    TextPart2: PropTypes.string,
    DisplayUrl: PropTypes.string,
    Path1: PropTypes.string,
    Path2: PropTypes.string,
  }),
};

DynamicSearchAdPreview.defaultProps = {
  ad: {},
};
